import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = ({ fill = "black", fillOpacity = 1 }) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M8.6 7.76V5.6C8.6 5.43 8.5425 5.2875 8.4275 5.1725C8.3125 5.0575 8.17 5 8 5C7.83 5 7.6875 5.0575 7.5725 5.1725C7.4575 5.2875 7.4 5.43 7.4 5.6V7.985C7.4 8.065 7.415 8.1425 7.445 8.2175C7.475 8.2925 7.52 8.36 7.58 8.42L9.56 10.4C9.67 10.51 9.81 10.565 9.98 10.565C10.15 10.565 10.29 10.51 10.4 10.4C10.51 10.29 10.565 10.15 10.565 9.98C10.565 9.81 10.51 9.67 10.4 9.56L8.6 7.76ZM8 14C7.17 14 6.39 13.8425 5.66 13.5275C4.93 13.2125 4.295 12.785 3.755 12.245C3.215 11.705 2.7875 11.07 2.4725 10.34C2.1575 9.61 2 8.83 2 8C2 7.17 2.1575 6.39 2.4725 5.66C2.7875 4.93 3.215 4.295 3.755 3.755C4.295 3.215 4.93 2.7875 5.66 2.4725C6.39 2.1575 7.17 2 8 2C8.83 2 9.61 2.1575 10.34 2.4725C11.07 2.7875 11.705 3.215 12.245 3.755C12.785 4.295 13.2125 4.93 13.5275 5.66C13.8425 6.39 14 7.17 14 8C14 8.83 13.8425 9.61 13.5275 10.34C13.2125 11.07 12.785 11.705 12.245 12.245C11.705 12.785 11.07 13.2125 10.34 13.5275C9.61 13.8425 8.83 14 8 14Z"
      fill={fill}
      fillOpacity={fillOpacity}
    />
  </Svg>
);
export default SVGComponent;
